import React from "react";
import { Button } from "antd";
import Icon from "@mdi/react";
import { mdiMinus, mdiPlus } from "@mdi/js";
import { CruiseCabinPax, addCabin, cabinPaxTotal, changeCabinGuest, removeCabin } from "../../utils/cruise";

export type { CruiseCabinPax };

const Stepper = (props: {
  value: number;
  onDecrease: () => void;
  onIncrease: () => void;
  decreaseDisabled?: boolean;
  increaseDisabled?: boolean;
}) => (
  <div className="traveler-actions">
    <Button
      shape="circle"
      type="primary"
      icon={<Icon path={mdiMinus} size="20px" />}
      onClick={props.onDecrease}
      disabled={props.decreaseDisabled}
    />
    {props.value}
    <Button
      shape="circle"
      type="primary"
      icon={<Icon path={mdiPlus} size="20px" />}
      onClick={props.onIncrease}
      disabled={props.increaseDisabled}
    />
  </div>
);

const CruiseTravelers: React.FC<{
  cabins: CruiseCabinPax[];
  setCabins: React.Dispatch<React.SetStateAction<CruiseCabinPax[]>>;
  multiplier: number;
  maxCabins: number;
  disabled?: boolean;
}> = ({ cabins, setCabins, multiplier, maxCabins, disabled }) => {
  const changeCabinCount = (delta: number) => {
    setCabins((prev) => (delta > 0 ? addCabin(prev, multiplier, maxCabins) : removeCabin(prev)));
  };

  const changeGuest = (index: number, key: keyof CruiseCabinPax, delta: number) => {
    setCabins((prev) => changeCabinGuest(prev, index, key, delta, multiplier));
  };

  if (disabled) {
    return (
      <div className="cruise-travelers_empty">
        <small>Select a room type and cabin to choose travelers.</small>
      </div>
    );
  }

  return (
    <div className="cruise-travelers">
      <div className="traveler-category">
        <span className="traveler-category-label">Cabin</span>
        <Stepper
          value={cabins.length}
          onDecrease={() => changeCabinCount(-1)}
          onIncrease={() => changeCabinCount(1)}
          decreaseDisabled={cabins.length <= 1}
          increaseDisabled={cabins.length >= maxCabins}
        />
      </div>

      <div className="cruise-travelers_cabins">
        {cabins.map((cabin, index) => {
          const cabinFull = cabinPaxTotal(cabin) >= multiplier;
          return (
            <div className="cruise-travelers_cabin-card" key={index}>
              <div className="cruise-travelers_cabin-title">
                <span>Cabin {index + 1}</span>
                <small>Max. {multiplier} guests per cabin</small>
              </div>

              <div className="cruise-travelers_guest-rows">
                <div className="cruise-travelers_guest-row">
                  <div className="cruise-travelers_guest-labels">
                    <span>Adult</span>
                    <small>12 years &amp; above</small>
                  </div>
                  <Stepper
                    value={cabin.adult}
                    onDecrease={() => changeGuest(index, "adult", -1)}
                    onIncrease={() => changeGuest(index, "adult", 1)}
                    decreaseDisabled={cabin.adult <= 0}
                    increaseDisabled={cabinFull}
                  />
                </div>

                <div className="cruise-travelers_guest-row">
                  <div className="cruise-travelers_guest-labels">
                    <span>Children</span>
                    <small>2-11 years old</small>
                  </div>
                  <Stepper
                    value={cabin.children}
                    onDecrease={() => changeGuest(index, "children", -1)}
                    onIncrease={() => changeGuest(index, "children", 1)}
                    decreaseDisabled={cabin.children <= 0}
                    increaseDisabled={cabinFull}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CruiseTravelers;
